export default {
	label: '设备技术员',
	id: '0',
	children: [
		{
			label: '岗位职责',
			id: '0-2',
			children: [
				{
					label: '负责设备台账记录、设计图纸的规整、编制与存档',
					id: '0-2-1',
				},
				{
					label: '负责设备相关采购计划申报、跟进，到货验收工作',
					id: '0-2-2',
				},
				{
					label: '参与设备系统检修计划编制和相关具体工作',
					id: '0-2-3',
				},
				{
					label: '参与或负责现场设备故障判断',
					id: '0-2-4',
				},
				{
					label: '参与设备改造相关工作和设备安装调试与验收工作',
					id: '0-2-5',
				}
			]
		},
		{
			label: '技术要求',
			id: '0-3',
			children: [
				{
					label: '机械类专业、电气工程、自动化、测控技术与仪器等专业',
					id: '0-3-1',
				},
				{
					label: '具备持续学习能力',
					id: '0-3-2',
				},
				{
					label: '熟练掌握电脑制图与办公软件',
					id: '0-3-3',
				}
			]
		}
	]
}